import {withRouter} from 'react-router';
import {get as _get, isEmpty as _isEmpty} from 'lodash';

import {withApollo} from 'react-apollo';
import EventForm from '@modules/events/forms/EventForm';
import {showErrorModal} from '@utils/modal';
import {getLink} from '@appComponents/Link';

import {
    dataToSave,
    setStageFields,
    setPropertyLicenceFieldOptions,
    loadStageDataHelper,
    resetStageDateTimeFields,
    stageEventExists,
} from './stageFormHelper';

class ExistingStageEventForm extends EventForm {
    componentDidMount() {
        super.componentDidMount();

        void this.checkStageEventExists();

        this.setCreateErrorCallback(() => {
            this.props.Modal.setModal({
                isVisible: false,
            });
        });

        this.setCreateSuccessCallback((response) => {
            this.props.history.push(getLink('events.configuration.index',
                {id: response.data.createStEvent.event.id}));
        });

        loadStageDataHelper(this);

        this.setOnChangeCallback({
            'property_licence': (data) => {
                this.setState(() => ({
                    selectedPropertyLicenceId: data.value,
                }), () => {
                    this.resetCoverageField();
                });

                if (this.props.Model.editModel) {
                    return;
                }

                this.getPresetsForPropertyLicence(
                    data.value, _get(this.state, 'defaultForm_data.event.id', null)
                );

                this.setField('event_preset', {
                    defaultValue: null,
                    timestamp: Date.now(),
                });
            },
            'synchronise_times': (data) => {
                if (this.props.formValues.property_licence) {
                    this.setField(['start_datetime', 'end_datetime'], {
                        disabled: !data.value,
                    });
                }

                if (!data.value) {
                    resetStageDateTimeFields(this.setField, this.state.stageData);
                }
            },
        });
    }

    componentDidUpdate(prevProps, prevState) {
        setPropertyLicenceFieldOptions(this, prevProps, prevState);

        const {property_licence, stage_category_id} = this.props.formValues;

        this.setCoverageField(prevProps, null, null, false, false, stage_category_id);
        this.toggleClipProvidersDropdown(prevProps, prevState);

        if (
            !_isEmpty(this.state.stageData) &&
            this.state.stageData !== prevState.stageData
        ) {
            setStageFields(this.setField, this.state.stageData?.stage)
                .catch((e) => showErrorModal({
                    header: 'Error',
                    text: e.message})
                );

            this.setField('stage_category_id', {
                defaultValue: this.state.stageData.stage.stage_category.id,
            });
        }

        if (property_licence &&
            property_licence !== prevProps.formValues.property_licence
        ) {
            this.updateRightsScopesDatesRange(property_licence);
        }
    }

    checkStageEventExists = () => {
        return stageEventExists(this.props.formParams.optionsVariables.stageId).then((data) => {
            if (data?.stageEventId) {
                showErrorModal({
                    header: 'Stage error',
                    text: 'Stage already linked to event!',
                    errorButtonText: 'Open event',
                    errorButtonIcon: 'arrow circle left',
                    redirectLink: getLink('events.configuration.index',
                        {
                            id: data.stageEventId,
                        }),
                });
            }
        });
    };

    prepareDataForSubmit = (data) => {
        return dataToSave(this, data);
    };

    renderSaveButton = () => {
        return super.renderSaveButton();
    };

    renderDeleteButton = () => {};
}

export default withRouter(withApollo(ExistingStageEventForm));
